code {
  display: block;
  background-color: var(--apie-stacktrace-code-background-color);
}

code::before {
  margin-right: 1em;
  color: var(--apie-stacktrace-code-text-color);
}

code.highlighted {
  background-color: var(--apie-stacktrace-code-highlight-color);
}